import * as React from "react";
import { ProductContext } from "./ProductContext.js";
import { isAccessories, isContactLens, isFrames, isProductWithAFrame, isSunglasses, isSolutions } from "../../types/types/typeguards.js";
function useInternalProductData() {
  const context = React.useContext(
    ProductContext
  );
  if (!context) {
    throw new Error(
      `No ${ProductContext.displayName} available. You might need to add the ${ProductContext.displayName} provider component.`
    );
  }
  return context;
}
const wrongProductTypeError = ({ productType, masterSku }, expectedType) => {
  throw new Error(
    `Tried to use the wrong product data context. Expected "${expectedType}" but got "${productType}" for sku: ${masterSku}`
  );
};
function useProductData() {
  const context = useInternalProductData();
  return context;
}
const useSunglassesProductData = () => {
  const context = useInternalProductData();
  if (!isSunglasses(context.product)) wrongProductTypeError(context.product, "Sunglasses");
  return context;
};
const useFramesProductData = () => {
  const context = useInternalProductData();
  if (!isFrames(context.product)) wrongProductTypeError(context.product, "Frames");
  return context;
};
const useAccessoriesProductData = () => {
  const context = useInternalProductData();
  if (!isAccessories(context.product)) wrongProductTypeError(context.product, "Accessories");
  return context;
};
const useContactLensProductData = () => {
  const context = useInternalProductData();
  if (!isContactLens(context.product)) wrongProductTypeError(context.product, "Contact-lenses");
  return context;
};
const useSolutionsProductData = () => {
  const context = useInternalProductData();
  if (!isSolutions(context.product)) wrongProductTypeError(context.product, "Solutions");
  return context;
};
const useProductWithAFrameData = () => {
  const context = useInternalProductData();
  if (!isProductWithAFrame(context.product)) {
    wrongProductTypeError(context.product, "A product with a frame");
  }
  return context;
};
export {
  useAccessoriesProductData,
  useContactLensProductData,
  useFramesProductData,
  useProductData,
  useProductWithAFrameData,
  useSolutionsProductData,
  useSunglassesProductData
};
//# sourceMappingURL=product-context-hooks.js.map
